module.exports = __webpack_public_path__ + "static/media/BackProgressDesktop.daba38d6.svg";